import { ConcreteException } from '../base.js';
export class WalletException extends ConcreteException {
    static errorClass = 'WalletException';
    parse() {
        this.setName(WalletException.errorClass);
    }
}
